import React from "react";

interface DetailField {
  label: string;
  value?: React.ReactNode;
}

interface DetailsCardProps {
  inConsent?: boolean;
  title: React.ReactNode;
  columns?: DetailField[][];
  className?: string;
  beforeColumns?: React.ReactNode;
  afterColumns?: React.ReactNode;
  isHeader?: boolean;
}

export const DetailsCard: React.FC<DetailsCardProps> = ({
  inConsent = false,
  title,
  columns,
  className = "",
  beforeColumns,
  afterColumns,
  isHeader = true,
}) => {
  return (
    <div
      className={`${isHeader && "border border-[#0082CA]"} rounded-[5px] bg-white overflow-hidden ${className}`}
    >
      {isHeader && (
        <div className="bg-[#e7eeff] border-b border-[#0082CA] px-6 py-3">
          <h2 className="text-base font-medium text-gray-500">{title}</h2>
        </div>
      )}
      <div className={inConsent ? `bg-[#f7f8fc]` : `px-6 py-4 bg-[#f7f8fc]`}>
        {beforeColumns && <div>{beforeColumns}</div>}

        {columns?.length && (
          <div className="grid gap-x-16 gap-y-4 md:grid-cols-2">
            {columns.map((col, colIndex) => (
              <div key={colIndex} className="space-y-5">
                {col.map((field, idx) => (
                  <div key={idx} className="flex text-sm m">
                    <span className="w-48 text-gray-300">{field.label}</span>
                    <span className="text-gray-500">{field.value ?? "-"}</span>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

        {afterColumns && <div>{afterColumns}</div>}
      </div>
    </div>
  );
};
